export const CHEMICAL_DB_API_HOST = import.meta.env.VITE_CHEMICAL_DB_API_BASE_URL;

export const CHEMICALS_API = '/api/chemicals';

export const JSON_HEADERS = { 'Content-Type': 'application/json' };

export const HTTP_STATUS_FORBIDDEN = '403';

export const HTTP_STATUS_NOT_FOUND = '404';

export const HTTP_STATUS_RATE_LIMITED = '429';

export const HTTP_STATUS_BAD_GATEWAY = '502';
